// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__1bpsE","Div":"CustomFadeBox_Div__19WXf","LargeDiv":"CustomFadeBox_LargeDiv__P-W38"};